var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vuestic-checkbox", class: _vm.computedClass },
    [
      _c(
        "div",
        {
          staticClass: "vuestic-checkbox__square",
          class: { active: _vm.value },
          on: {
            click: function ($event) {
              _vm.toggleSelection(), (_vm.focused = false)
            },
            mousedown: function ($event) {
              _vm.focused = true
            },
          },
        },
        [
          _c("input", {
            staticClass: "vuestic-checkbox__input",
            attrs: { id: _vm.id, readonly: "", disabled: _vm.disabled },
            on: {
              focus: function ($event) {
                _vm.focused = true
              },
              mouseout: function ($event) {
                _vm.focused = false
              },
              blur: function ($event) {
                _vm.focused = false
              },
              keypress: function ($event) {
                return _vm.toggleSelection()
              },
            },
          }),
          _c("i", {
            staticClass: "ion ion-md-checkmark vuestic-checkbox__icon-selected",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vuestic-checkbox__label-text",
          on: { click: _vm.toggleSelection },
        },
        [
          _vm._t("label", function () {
            return [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]
          }),
        ],
        2
      ),
      _vm.showError
        ? _c(
            "div",
            { staticClass: "vuestic-checkbox__error-message-container" },
            _vm._l(_vm.computedErrorMessages, function (error, index) {
              return _c(
                "span",
                { key: index, staticClass: "vuestic-checkbox__error-message" },
                [_vm._v("\n          " + _vm._s(error) + "\n      ")]
              )
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }